import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import Pagination from '../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';

const InstituteCompetitiveExamTopicMaster = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        instituteCompetitiveExamNameMasterId: '',
        instituteCompetitiveLessonMasterId: '',
        competitiveTopicNames: [''],
        instituteSubjectMasterId: '',
        instituteCompetitiveExamBookMasterId: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [topicData, setTopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [bookList, setBookList] = useState([])
    const [subjectList, setSubjectList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);
    const [topicNameSort, setTopicNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteCompetitiveExamNameMasterDetails.examName", "instituteCompetitiveExamBookMasterDetails.bookName", "instituteSubjectMasterDetails.subjectName", "instituteCompetitiveLessonMasterDetails.competitiveLessonName", "competitiveTopicName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getTopicList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setTopicList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(topicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(topicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > topicList.length) {
            endIndex = topicList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(topicList.slice(startIndex, endIndex));
    }, [topicList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = '/get-institute-competitive-topic-master?';

        if (topicData.instituteCompetitiveExamBookMasterId) {
            apiUrl += `instituteCompetitiveExamBookMasterId=${topicData.instituteCompetitiveExamBookMasterId}&`;
        }

        if (topicData.instituteMasterId) {
            apiUrl += `instituteMasterId=${topicData.instituteMasterId}&`;
        }

        if (topicData.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${topicData.instituteSubjectMasterId}&`;
        }

        if (topicData.instituteCompetitiveLessonMasterId) {
            apiUrl += `instituteCompetitiveLessonMasterId=${topicData.instituteCompetitiveLessonMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        if (topicData.instituteCompetitiveExamNameMasterId.length !== 0 && topicData.instituteCompetitiveExamBookMasterId !== '' && topicData.instituteSubjectMasterId.length !== 0) {
            getTopicList();
        }
    }, [topicData.instituteSubjectMasterId]);

    const getTopicList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setTopicList(response.data.result);
        } catch (error) {
            setTopicList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e, index) => {
        setTopicData((prevData) => {
            if (e.target.name === 'competitiveTopicNames') {
                // Update the value at the specified index
                const updatedTopicName = [...prevData.competitiveTopicNames];
                updatedTopicName[index] = e.target.value;
                return {
                    ...prevData,
                    competitiveTopicNames: updatedTopicName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }
    const handleAddTopic = () => {
        setTopicData((prevData) => ({
            ...prevData,
            competitiveTopicNames: [...prevData.competitiveTopicNames, ''],
        }));
    };

    const handleRemoveTopic = (index) => {
        setTopicData((prevData) => {
            const updatedTopicName = [...prevData.competitiveTopicNames];
            // Remove the element at the specified index
            updatedTopicName.splice(index, 1);
            return {
                ...prevData,
                competitiveTopicNames: updatedTopicName,
            }
        });
    }

    const handleSyllabusChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveExamBookMasterId: '',
                instituteCompetitiveLessonMasterId: '',
                instituteSubjectMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteSubjectMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setTopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${topicData.instituteCompetitiveExamBookMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(topicData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(topicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [topicData])

    const addTopic = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-competitive-topic-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, topicData)
                await getTopicList();
                setTopicData((prevData) => {
                    return {
                        ...prevData,
                        competitiveTopicNames: [''],
                    }
                })

                setSaveId(response.data.result[0].id);
                setExamNameSort(null);
                setBookNameSort(null);
                setSubjectNameSort(null);
                setLessonNameSort(null);
                setTopicNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(topicData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteTopic = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-competitive-topic-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl)
                const page = deleteItem(currPage, itemsPerPage, topicList.length);
                await getTopicList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateTopic = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-competitive-topic-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, { competitiveTopicNames: topicData?.competitiveTopicNames[0] })
            await getTopicList();
            setEditId(null);
            setTopicData((prevData) => {
                return {
                    ...prevData,
                    competitiveTopicNames: [''],
                }
            })

            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setLessonNameSort(null);
            setTopicNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setTopicNameSort(null);
        }
    }, [lessonNameSort])

    useEffect(() => {
        if (topicNameSort == true || topicNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [topicNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Topic  Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-hashtag"></i> Competitive Exam Topic Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSyllabusChange} value={topicData.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamNameMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveExamBookMasterId' onChange={handleBookChange} value={topicData.instituteCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamBookMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={topicData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {console.log("subject List", subjectList)}
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                console.log("syllabus", syllabus);
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveLessonMasterId' onChange={handleInputChange} value={topicData.instituteCompetitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveLessonMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveLessonMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                {topicData?.competitiveTopicNames?.map((topic, index) => (
                                                    <>
                                                        <div className="col-md-11">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Topic Name :</label>
                                                            <input type="text" className="form-control" id={`competitiveTopicNames${index}`} name='competitiveTopicNames' onChange={(e) => handleInputChange(e, index)} value={topic} />
                                                            {error.competitiveTopicNames && <p style={{ color: 'red' }}>{error.competitiveTopicNames}</p>}

                                                        </div>
                                                        {topicData.competitiveTopicNames.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveTopic(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '220px' }} onClick={handleAddTopic}>+ Add Another Topic Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setTopicList([]); setEditId(''); setTopicData(initialFormState) }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateTopic} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveLessonMasterDetails.competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic Name
                                                                            <SortIcon sortState={topicNameSort} setSortState={setTopicNameSort} setData={setTopicList} setCurrPage={setCurrPage} sortingPath={"competitiveTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((topic, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{topic.instituteCompetitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{topic.instituteCompetitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{topic.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                        <td>{topic.instituteCompetitiveLessonMasterDetails?.competitiveLessonName}</td>
                                                                                        <td>{topic.competitiveTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn-outline-warning edit_icon" title='Coming Soon...' disabled type="button" onClick={() => {
                                                                                                setTopicData({
                                                                                                    competitiveTopicNames: [topic?.competitiveTopicNames],
                                                                                                });
                                                                                                setEditId(topic.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn-outline-danger delete_icon" title='Coming Soon...' disabled type="button" /*disabled={editId === topic.id}*/ onClick={() => deleteTopic(topic.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Competitive Exam Topic Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={topicList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteCompetitiveExamTopicMaster;